import Route from '@ember/routing/route';
import RouterService from '@ember/routing/router-service';
import { service } from '@ember/service';

export default class PslfEmployerRoute extends Route {
  @service declare router: RouterService;

  queryParams = {
    approval: { refreshModel: true, replace: true },
  };

  model(params: { form_document_id: string }) {
    const { form_document_id } = params;
    // form_document_id is an opaque path segment (now an encoded approval token; previously a
    // SignNow-era document_id). It's kept on the model only for legacy template consumers — all
    // backend lookups happen via the `approval` query param.
    return {
      documentId: form_document_id,
    };
  }

  afterModel() {
    this.router.transitionTo('pslf-employer.non-partner-sign');
  }
}
